/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Basic authentication credentials. Required when `authMethod` is `basic`.
 * @export
 * @interface SetCustomEmailSettingsRequestSettingsBasicAuth
 */
export interface SetCustomEmailSettingsRequestSettingsBasicAuth {
    /**
     * SMTP username.
     */
    user: string;
    /**
     * SMTP password.
     */
    password: string;
}

/**
 * Check if a given object implements the SetCustomEmailSettingsRequestSettingsBasicAuth interface.
 */
export function instanceOfSetCustomEmailSettingsRequestSettingsBasicAuth(value: object): value is SetCustomEmailSettingsRequestSettingsBasicAuth {
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function SetCustomEmailSettingsRequestSettingsBasicAuthFromJSON(json: any): SetCustomEmailSettingsRequestSettingsBasicAuth {
    return SetCustomEmailSettingsRequestSettingsBasicAuthFromJSONTyped(json, false);
}

export function SetCustomEmailSettingsRequestSettingsBasicAuthFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetCustomEmailSettingsRequestSettingsBasicAuth {
    if (json == null) {
        return json;
    }
    return {
        
        'user': json['user'],
        'password': json['password'],
    };
}

export function SetCustomEmailSettingsRequestSettingsBasicAuthToJSON(json: any): SetCustomEmailSettingsRequestSettingsBasicAuth {
    return SetCustomEmailSettingsRequestSettingsBasicAuthToJSONTyped(json, false);
}

export function SetCustomEmailSettingsRequestSettingsBasicAuthToJSONTyped(value?: SetCustomEmailSettingsRequestSettingsBasicAuth | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user': value['user'],
        'password': value['password'],
    };
}

